// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__UJYRv","centerWrap":"styles_centerWrap__ALvxA","loading":"styles_loading__Czw8Z","loadingCycle":"styles_loadingCycle__LSos1"};